import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { z } from "zod";

const VALID_STEPS = ["stap1", "stap2", "stap3"] as const;
type ValidStep = (typeof VALID_STEPS)[number];

const searchSchema = z.object({
  contractId: z.string().optional(),
  sh_id: z.string().optional(),
});

export const Route = createFileRoute("/(authenticated)/betaling-instellen/$step")({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    if (!VALID_STEPS.includes(params.step as ValidStep)) {
      throw notFound();
    }
    if (params.step === "stap1") {
      throw redirect({ to: "/uitbetaling-instellen" });
    }
    if (params.step === "stap2") {
      throw redirect({ to: "/dashboard", search: { machtiging: "stap1" } });
    }
    throw redirect({
      to: "/dashboard",
      search: {
        machtiging: "stap2",
        contractId: search.contractId,
        sh_id: search.sh_id,
      },
    });
  },
});
